var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade",
        attrs: {
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "myModalLabel"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h4",
                  { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                  [_vm._v(_vm._s(_vm.$t("txtDuty")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$refs.helpModal.open()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-question" })]
                )
              ]),
              _vm._v(" "),
              _vm.dutyCreate
                ? _c(
                    "div",
                    { staticClass: "modal-body" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("txtDutyName")) +
                          "\n\n                    "
                      ),
                      _c(
                        "form-wizard",
                        {
                          ref: "addModalFormWizard",
                          attrs: {
                            color: "#0067a3",
                            "back-button-text": _vm.$t("btnBack"),
                            "next-button-text": _vm.$t("btnNext"),
                            "finish-button-text": _vm.$t("btnFinish")
                          },
                          on: { "on-complete": _vm.onComplete }
                        },
                        [
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: _vm.$t("txtDutyBasic"),
                                icon: "fas fa-file-signature"
                              }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("txtDutyName")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-8" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.dutyCreate.duty.title,
                                        expression: "dutyCreate.duty.title"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.dutyCreate.duty.title
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.dutyCreate.duty,
                                          "title",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm.isMaintenance == true
                                    ? _c("div", [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("txtDutyCell"))
                                        )
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("txtObject"))
                                        )
                                      ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-8" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        multiple: "",
                                        label: "name",
                                        options: _vm.cellsForVSelect
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function(option) {
                                              return [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(option.name) +
                                                    "\n                                "
                                                ),
                                                option.ident &&
                                                option.ident.trim().length
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-secondary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                  " +
                                                            _vm._s(
                                                              option.ident
                                                            ) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          },
                                          {
                                            key: "selected-option",
                                            fn: function(option) {
                                              return [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(option.name) +
                                                    "\n                                "
                                                ),
                                                option.ident &&
                                                option.ident.trim().length
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-secondary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                  " +
                                                            _vm._s(
                                                              option.ident
                                                            ) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        888616333
                                      ),
                                      model: {
                                        value: _vm.dutyCreateCells,
                                        callback: function($$v) {
                                          _vm.dutyCreateCells = $$v
                                        },
                                        expression: "dutyCreateCells"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("txtDutyEmails")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-8" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        multiple: "",
                                        label: "email",
                                        options: _vm.users
                                      },
                                      model: {
                                        value: _vm.dutyCreate.users,
                                        callback: function($$v) {
                                          _vm.$set(_vm.dutyCreate, "users", $$v)
                                        },
                                        expression: "dutyCreate.users"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("dutyTecharea")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-8" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.techAreaOptions,
                                        taggable: _vm.canNewTechArea,
                                        clearable: true
                                      },
                                      model: {
                                        value: _vm.dutyCreate.duty.techArea,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dutyCreate.duty,
                                            "techArea",
                                            $$v
                                          )
                                        },
                                        expression: "dutyCreate.duty.techArea"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("dutyLabel")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-8" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.dutyCreate.duty.label,
                                        expression: "dutyCreate.duty.label"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.dutyCreate.duty.label
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.dutyCreate.duty,
                                          "label",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("txtCostCenter")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-8" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.dutyCreate.duty.costCenter,
                                        expression: "dutyCreate.duty.costCenter"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.dutyCreate.duty.costCenter
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.dutyCreate.duty,
                                          "costCenter",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("duty.ratePerHour")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-8" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.dutyCreate.duty.ratePerHour,
                                        expression:
                                          "dutyCreate.duty.ratePerHour"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.dutyCreate.duty.ratePerHour
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.dutyCreate.duty,
                                          "ratePerHour",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("txtDutyTrigger")) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-8" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        label: "name",
                                        options: _vm.dutyCreate.triggers,
                                        reduce: triggers => triggers.id
                                      },
                                      model: {
                                        value: _vm.dutyCreate.triggerSelected,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dutyCreate,
                                            "triggerSelected",
                                            $$v
                                          )
                                        },
                                        expression: "dutyCreate.triggerSelected"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _vm.dutyCreate.triggerSelected === 0
                                ? _c("div")
                                : _c("div", [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-md-4" }, [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.$t("txtTrigger")) +
                                            "\n                            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-8" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.triggers[1]
                                                  .triggerValue,
                                              expression:
                                                "dutyCreate.triggers[1].triggerValue"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("txtIgnTrigger")
                                          },
                                          domProps: {
                                            value:
                                              _vm.dutyCreate.triggers[1]
                                                .triggerValue
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.dutyCreate.triggers[1],
                                                "triggerValue",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.triggers[1]
                                                  .ignDb,
                                              expression:
                                                "dutyCreate.triggers[1].ignDb"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("txtIgnDb")
                                          },
                                          domProps: {
                                            value:
                                              _vm.dutyCreate.triggers[1].ignDb
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.dutyCreate.triggers[1],
                                                "ignDb",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.triggers[1]
                                                  .ignTable,
                                              expression:
                                                "dutyCreate.triggers[1].ignTable"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("txtIgnTable")
                                          },
                                          domProps: {
                                            value:
                                              _vm.dutyCreate.triggers[1]
                                                .ignTable
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.dutyCreate.triggers[1],
                                                "ignTable",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.triggers[1]
                                                  .ignFieldValue,
                                              expression:
                                                "dutyCreate.triggers[1].ignFieldValue"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("txtIgnField")
                                          },
                                          domProps: {
                                            value:
                                              _vm.dutyCreate.triggers[1]
                                                .ignFieldValue
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.dutyCreate.triggers[1],
                                                "ignFieldValue",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ])
                                    ])
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: _vm.$t("txtDatePattern"),
                                icon: "fas fa-calendar-alt"
                              }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    _c("span", { staticClass: "small pr-1" }, [
                                      _vm._v(_vm._s(_vm.$t("txtStartDate")))
                                    ]),
                                    _vm._v(" "),
                                    _c("date-picker", {
                                      attrs: { "bootstrap-styling": true },
                                      model: {
                                        value: _vm.dateStart,
                                        callback: function($$v) {
                                          _vm.dateStart = $$v
                                        },
                                        expression: "dateStart"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" }, [
                                  _c("span", { staticClass: "small pr-1" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("dutyAdvancedNotification")
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.dutyCreate.duty
                                              .advancedReminderHours,
                                          expression:
                                            "dutyCreate.duty.advancedReminderHours"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.dutyCreate.duty,
                                            "advancedReminderHours",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { domProps: { value: 0 } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("generalDisabled"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 24 } },
                                        [
                                          _vm._v(
                                            _vm._s("1 " + _vm.$t("generalDay"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 120 } },
                                        [
                                          _vm._v(
                                            _vm._s("5 " + _vm.$t("generalDays"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 720 } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              "30 " + _vm.$t("generalDays")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" }, [
                                  _c("span", { staticClass: "small pr-1" }, [
                                    _vm._v(_vm._s(_vm.$t("dutyDueTimespan")))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value: _vm.dueWeeks,
                                          expression: "dueWeeks",
                                          modifiers: { number: true }
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", min: "0" },
                                      domProps: { value: _vm.dueWeeks },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.dueWeeks = _vm._n(
                                            $event.target.value
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value: _vm.dueDays,
                                          expression: "dueDays",
                                          modifiers: { number: true }
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        min:
                                          _vm.dutyCreate.duty.dueSeconds >=
                                          3600 * 24 * 7
                                            ? -1
                                            : 0
                                      },
                                      domProps: { value: _vm.dueDays },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.dueDays = _vm._n(
                                            $event.target.value
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value: _vm.dueHours,
                                          expression: "dueHours",
                                          modifiers: { number: true }
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        min:
                                          _vm.dutyCreate.duty.dueSeconds >=
                                          3600 * 24
                                            ? -1
                                            : 0
                                      },
                                      domProps: { value: _vm.dueHours },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.dueHours = _vm._n(
                                            $event.target.value
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" }, [
                                  _c("span", { staticClass: "small pr-1" }, [
                                    _vm._v(_vm._s(_vm.$t("dutyDisabled")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-group form-check" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.dutyCreate.duty.isDisabled,
                                            expression:
                                              "dutyCreate.duty.isDisabled"
                                          }
                                        ],
                                        staticClass: "form-check-input",
                                        staticStyle: {
                                          width: "1.5em",
                                          height: "1.5em"
                                        },
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.dutyCreate.duty.isDisabled
                                          )
                                            ? _vm._i(
                                                _vm.dutyCreate.duty.isDisabled,
                                                null
                                              ) > -1
                                            : _vm.dutyCreate.duty.isDisabled
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a =
                                                _vm.dutyCreate.duty.isDisabled,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.dutyCreate.duty,
                                                    "isDisabled",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.dutyCreate.duty,
                                                    "isDisabled",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.dutyCreate.duty,
                                                "isDisabled",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("span", { staticClass: "small pr-1" }, [
                                    _vm._v(_vm._s(_vm.$t("txtDatePattern")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.dutyCreate.duty.datePattern,
                                          expression:
                                            "dutyCreate.duty.datePattern"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.dutyCreate.duty,
                                              "datePattern",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function($event) {
                                            _vm.$nextTick(() =>
                                              _vm.onDutyCreateChangeDatePatternChanged(
                                                _vm.dutyCreate.duty.datePattern
                                              )
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: 16 } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("txtDataPatternOnce"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("option", { domProps: { value: 0 } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("txtDataPatternDaily"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { domProps: { value: 1 } }, [
                                        _vm._v(_vm._s(_vm.$t("txtDataYMD")))
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { domProps: { value: 2 } }, [
                                        _vm._v(_vm._s(_vm.$t("txtDataYWD")))
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { domProps: { value: 4 } }, [
                                        _vm._v(_vm._s(_vm.$t("txtDataYMDoW")))
                                      ])
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  staticStyle: { "padding-top": "15px" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.intervalDisabled,
                                          expression: "!intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("txtDateIntervall"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.duty.firstDate
                                                  .repeatInterval,
                                              expression:
                                                "dutyCreate.duty.firstDate.repeatInterval"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: _vm.intervalDisabled
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.dutyCreate.duty.firstDate,
                                                "repeatInterval",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("Niemals")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(366, function(n) {
                                            return _c(
                                              "option",
                                              {
                                                key: n,
                                                domProps: { value: n }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(n) +
                                                    "\n                                  "
                                                )
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "730" } },
                                            [_vm._v("2. Jahre")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "1095" } },
                                            [_vm._v("3. Jahre")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "1460" } },
                                            [_vm._v("4. Jahre")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "1825" } },
                                            [_vm._v("5. Jahre")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "2190" } },
                                            [_vm._v("6. Jahre")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "2555" } },
                                            [_vm._v("7. Jahre")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { domProps: { value: 12 * 365 } },
                                            [_vm._v("12. Jahre")]
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "duty.editmodal.tipInterval"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.intervalDisabled,
                                          expression: "intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("txtYearIntervall"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "yearMultiSelect",
                                        attrs: {
                                          multiple: "",
                                          label: "name",
                                          options: _vm.yearOptions,
                                          disabled: _vm.yearDisabled
                                        },
                                        model: {
                                          value: _vm.yearOptionSelected,
                                          callback: function($$v) {
                                            _vm.yearOptionSelected = $$v
                                          },
                                          expression: "yearOptionSelected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("duty.editmodal.tipYear")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.intervalDisabled,
                                          expression: "intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("txtMonthInterfall"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.duty.firstDate
                                                  .repeatMonth,
                                              expression:
                                                "dutyCreate.duty.firstDate.repeatMonth"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: _vm.monthDisabled
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.dutyCreate.duty.firstDate,
                                                "repeatMonth",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "*" } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("txtEachMonth"))
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(12, function(n) {
                                            return _c(
                                              "option",
                                              {
                                                key: n,
                                                domProps: { value: n }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(n) +
                                                    "\n                                  "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("duty.editmodal.tipMonth")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.intervalDisabled,
                                          expression: "intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("txtDayInterfall"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.dutyCreate.duty.firstDate
                                                  .repeatDay,
                                              expression:
                                                "dutyCreate.duty.firstDate.repeatDay"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: _vm.dayDisabled },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.dutyCreate.duty.firstDate,
                                                "repeatDay",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(31, function(n) {
                                          return _c(
                                            "option",
                                            { key: n, domProps: { value: n } },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(n) +
                                                  "\n                                  "
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("duty.editmodal.tipDay")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.intervalDisabled,
                                          expression: "intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.$t("txtWeekNumber")))
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "weekNumberMultiSelect",
                                        attrs: {
                                          multiple: "",
                                          label: "name",
                                          options: _vm.weekOption,
                                          disabled: _vm.weekNumberDisabled
                                        },
                                        model: {
                                          value: _vm.weekOptionSelected,
                                          callback: function($$v) {
                                            _vm.weekOptionSelected = $$v
                                          },
                                          expression: "weekOptionSelected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "duty.editmodal.tipCalendarweek"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.intervalDisabled,
                                          expression: "intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-md-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.$t("txtWeekOfMonth")))
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          multiple: "",
                                          label: "name",
                                          options: _vm.weekOfMonthOptions,
                                          reduce: opt => opt.id,
                                          disabled: _vm.weekOfMonthDisabled
                                        },
                                        model: {
                                          value: _vm.weekOfMonthOptionSelected,
                                          callback: function($$v) {
                                            _vm.weekOfMonthOptionSelected = $$v
                                          },
                                          expression:
                                            "weekOfMonthOptionSelected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "duty.editmodal.tipWeekOfMonth"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.intervalDisabled,
                                          expression: "intervalDisabled"
                                        }
                                      ],
                                      staticClass: "col-2"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("txtRepeatWeekday"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "weekDayMultiSelect",
                                        attrs: {
                                          multiple: "",
                                          label: "name",
                                          options: _vm.weekdayOption,
                                          disabled: _vm.weekdayDisabled
                                        },
                                        model: {
                                          value: _vm.weekdayOptionSelected,
                                          callback: function($$v) {
                                            _vm.weekdayOptionSelected = $$v
                                          },
                                          expression: "weekdayOptionSelected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "duty.editmodal.tipRepeatWeekday"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  staticStyle: { "padding-top": "15px" }
                                },
                                [
                                  _c("div", { staticClass: "col-2" }, [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.$t("dutyUtcHour")))
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value: _vm.repeatHour,
                                          expression: "repeatHour",
                                          modifiers: { number: true }
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number", min: "0" },
                                      domProps: { value: _vm.repeatHour },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.repeatHour = _vm._n(
                                            $event.target.value
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("duty.editmodal.tipHour"))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-1" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-9" }, [
                                    _vm.dutyCreate &&
                                    _vm.dutyCreate.duty.firstDate
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "alert alert-info py-2 px-3 mb-0 shadow-sm",
                                            staticStyle: {
                                              "border-left": "5px solid #17a2b8"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-baseline"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-eye mr-2 text-info"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "small mr-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("txtPreview")
                                                      ) + ":"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "small text-secondary"
                                                  },
                                                  [
                                                    _vm.dutyCreate.duty
                                                      .datePattern === 16
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "txtDataPatternOnce"
                                                                )
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatDate"
                                                                )(_vm.dateStart)
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.dutyCreate.duty
                                                      .datePattern === 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "txtDataPatternDaily"
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.dutyCreate
                                                                  .duty
                                                                  .firstDate
                                                                  .repeatInterval ||
                                                                  "x"
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "generalDays"
                                                                )
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.getFormattedHour()
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.dutyCreate.duty
                                                      .datePattern === 1
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                          " +
                                                              _vm._s(
                                                                _vm.getYearPreview()
                                                              ) +
                                                              ", " +
                                                              _vm._s(
                                                                _vm.getMonthPreview()
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "txtDayInterfall"
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.dutyCreate
                                                                  .duty
                                                                  .firstDate
                                                                  .repeatDay ||
                                                                  "*"
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.getFormattedHour()
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.dutyCreate.duty
                                                      .datePattern === 2
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                          " +
                                                              _vm._s(
                                                                _vm.getYearPreview()
                                                              ) +
                                                              ", " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "txtWeek"
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.dutyCreate
                                                                  .duty
                                                                  .firstDate
                                                                  .repeatWeek ||
                                                                  "*"
                                                              ) +
                                                              ", " +
                                                              _vm._s(
                                                                _vm.getWeekdayPreview()
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.getFormattedHour()
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.dutyCreate.duty
                                                      .datePattern === 4
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                          " +
                                                              _vm._s(
                                                                _vm.getYearPreview()
                                                              ) +
                                                              ", " +
                                                              _vm._s(
                                                                _vm.getMonthPreview()
                                                              ) +
                                                              ", " +
                                                              _vm._s(
                                                                _vm.getWeekOfMonthPreview()
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getWeekdayPreview()
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.getFormattedHour()
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: _vm.$t("txtTaskInfo"),
                                icon: "fas fa-tasks"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            Task\n                            "
                              ),
                              _c("todo-list", {
                                attrs: {
                                  json: _vm.dutyCreate.strJsonTodo,
                                  cells: _vm.cells,
                                  editable: true,
                                  editorMode: true
                                },
                                on: { change: _vm.updateTodolist }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: _vm.$t("dutyTabMisc"),
                                icon: "fas fa-asterisk"
                              }
                            },
                            [
                              _vm.dutyCreate
                                ? _c("MiscTab", {
                                    attrs: { dutyCreate: _vm.dutyCreate }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: _vm.$t("txtUpload"),
                                icon: "fas fa-upload"
                              }
                            },
                            [
                              _c("image-viewer", {
                                attrs: {
                                  isShowDelete: true,
                                  medias: _vm.dutyCreate.duty.files
                                },
                                on: { "removed-media": _vm.onMediaDeleted }
                              }),
                              _vm._v(" "),
                              _c("DropZone", {
                                attrs: { formId: "dutyedit" + _vm._uid },
                                on: { complete: _vm.onDzComplete }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("HelpModal", { ref: "helpModal" })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v(_vm._s(_vm.$t("btnClose")))]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }